import { jsx as _jsx } from "react/jsx-runtime";
import { initializeMultipleSelectorState, MultipleSelectorStateActions, reduceMultipleSelectorState, TagInputSelector, } from '@dossierhq/design';
import { useEffect, useReducer } from 'react';
import { SchemaEditorActions, } from '../../reducers/SchemaEditorReducer/SchemaEditorReducer.js';
function useSynchronizeMultipleSelectorState(fieldSelector, referenceOrLink, items, selectedIds, dispatchSchemaEditorState) {
    const [state, dispatch] = useReducer(reduceMultipleSelectorState, { items, selectedIds }, initializeMultipleSelectorState);
    useEffect(() => {
        dispatchSchemaEditorState(referenceOrLink === 'reference'
            ? new SchemaEditorActions.ChangeFieldAllowedEntityTypes(fieldSelector, state.selectedIds)
            : new SchemaEditorActions.ChangeFieldAllowedLinkEntityTypes(fieldSelector, state.selectedIds));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.selectedIds]);
    useEffect(() => {
        dispatch(new MultipleSelectorStateActions.UpdateItems(items));
    }, [items]);
    useEffect(() => {
        dispatch(new MultipleSelectorStateActions.SetSelection(selectedIds));
    }, [selectedIds]);
    return { state, dispatch };
}
export function FieldEntityTypeSelector({ fieldSelector, referenceOrLink, entityTypes, schemaEditorState, dispatchSchemaEditorState, }) {
    const items = schemaEditorState.entityTypes.map((it) => ({ id: it.name }));
    const { state, dispatch } = useSynchronizeMultipleSelectorState(fieldSelector, referenceOrLink, items, entityTypes, dispatchSchemaEditorState);
    return (_jsx(TagInputSelector, { clearLabel: "Clear", itemTag: (item) => ({ tag: item.id }), state: state, dispatch: dispatch }));
}
//# sourceMappingURL=FieldEntityTypeSelector.js.map